import { TaskDetailsOverviewComponent } from './task-details-overview.component';

export default angular
  .module('sfMobile.components.task-details-overview', [])
  .component('sfTaskDetailsOverview', TaskDetailsOverviewComponent).name;
